module.exports = __webpack_public_path__ + "img/m14.8f5b5027.jpg";